import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, forwardRef, inject, signal } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgbModalRef, NgbModal, NgbAccordionModule, NgbModalConfig, NgbActiveModal, NgbDropdownModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { Backend } from 'src/app/backend-interface/backend';
import { allFalse } from 'src/app/backend-interface/controllers-api/security-policies.controllers';
import { ActivatedDetector, Detectors, Policy } from 'src/app/service/global.service';
import { ToastService } from 'src/app/service/toast.service';
import { TranslationService } from 'src/app/service/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { forkJoin } from 'rxjs';
import { LoadingErrorComponent } from 'src/app/components/loading-error/loading-error.component';
import { ToastComponent } from 'src/app/components/toast/toast.component';
import { FormAddPolicyAndSimulationComponent } from '../form-add-policy-and-simulation/form-add-policy-and-simulation.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-form-policy',
  templateUrl: './form-policy.component.html',
  styleUrls: ['./form-policy.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    TranslateModule, 
    ReactiveFormsModule, 
    FormsModule,
    CommonModule,
    NgbAccordionModule,
    NgbDropdownModule,
    NgbModalModule,
    LoadingErrorComponent,
    ToastComponent,
    forwardRef(() => FormAddPolicyAndSimulationComponent),
    MatSlideToggleModule,
    MatCheckboxModule
  ],
  providers: [TranslationService, ToastService, NgbModal, NgbModalConfig, NgbActiveModal]
})
export class FormPolicyComponent implements OnInit {

  @Input() policy?: Policy;
  @Input() create?: boolean;
  @Input() nameClient?: string;
  @Output() editP = new EventEmitter<{ policy: Policy, toast: string, nameClient?: string }>();
  @Output() closeEvent = new EventEmitter<string>();
  @Output() action = new EventEmitter<string>();

  public editing = true;
  lPolicies: Policy[] = [];
  constructorForm = false;
  formDetectorActive = new UntypedFormGroup({});
  private modalref?: NgbModalRef;

  readonly translationService = inject(TranslationService);
  readonly toastService = inject(ToastService);
  readonly modalService = inject(NgbModal);

  // Signal pour l'état de chargement si besoin
  readonly loading = signal<boolean>(false);

  ngOnInit() {
   
    this.initFormActive();
  }

  openCenteredVertically({ content }: { content: any }) {
    this.modalref = this.modalService.open(content, { centered: true });
  }

  modaldismiss(action: string) {
    this.modalref?.close(action);
  }

  sendClose(action: string) {
    this.closeEvent.emit(action);
    this.toastService.clear();
  }

  async getAllPolicies() {
    this.lPolicies = await Backend.POLICIES.getPolicies();
  }

  async initFormActive() {
    if (this.policy) {
      await this.getAllPolicies();
      let itemP = this.lPolicies.find(elem => elem.name == this.policy!.name);
      if (itemP && this.lPolicies.includes(itemP)) {
        this.lPolicies.splice(this.lPolicies.indexOf(itemP), 1);
      }
      this.formDetectorActive.addControl('name', new UntypedFormControl(this.policy.name, [
        Validators.required,
        Backend.SETTINGS.noWhitespaceValidator(),
        Backend.POLICIES.notExistValidator(this.lPolicies)
      ]));
      Backend.POLICIES.getAllFamilyofDetectors(this.policy).forEach(elem =>
        this.formDetectorActive.addControl(elem.toLowerCase(), new UntypedFormGroup({}))
      );
      if (this.policy.bwVersion?.listDetectors) {
        for (let detect of this.policy.bwVersion.listDetectors) {
          this.initFormForDetect(detect);
        }
      }
      this.constructorForm = true;
    }
  }

  getAllFamilyofDetectors() {
    return Backend.POLICIES.getAllFamilyofDetectors(this.policy);
  }

  getAllDetectorOfFam(family: string) {
    return Backend.POLICIES.getDetectorsByFamily(this.policy, family);
  }

  scroolTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  public getFormControl(string: string) {
    return this.formDetectorActive.get(string) as UntypedFormControl;
  }

  initFormForDetect(detect: Detectors) {
    if (this.policy) {
      let activDetect: ActivatedDetector | undefined = this.policy?.activatedDetectors?.find(elem => {
        if (elem.policyDetectorId) {
          return elem.policyDetectorId.detector.name == detect.name && elem.policyDetectorId.detector.id == detect.id;
        } else { return false; }
      });
      if (activDetect?.policyDetectorId) {
        this.getFormFam(activDetect.policyDetectorId.detector.family.toLowerCase()).addControl(activDetect.policyDetectorId.detector.name, new UntypedFormGroup({
          active: new UntypedFormControl(true),
          status: new UntypedFormControl(activDetect.status)
        }));
        this.getFormFamDetect(activDetect.policyDetectorId.detector.family.toLowerCase(), activDetect.policyDetectorId.detector.name).addControl('typeactiveinapp', new UntypedFormGroup({
          in_demand: new UntypedFormControl({ value: activDetect.launchOnDemand, disabled: !this.getVDetector(detect.family, detect.name)['active'] }),
          periodic: new UntypedFormControl({ value: activDetect.launchOnPeriodic, disabled: !this.getVDetector(detect.family, detect.name)['active'] })
        },
          { validators: allFalse }))
      } else {
        this.getFormFam(detect.family.toLowerCase()).addControl(detect.name, new UntypedFormGroup({
          active: new UntypedFormControl(false),
          status: new UntypedFormControl(),
        }))
        this.getFormFamDetect(detect.family.toLowerCase(), detect.name).addControl('typeactiveinapp', new UntypedFormGroup({
          in_demand: new UntypedFormControl({ value: false, disabled: !this.getVDetector(detect.family, detect.name)['active'] }),
          periodic: new UntypedFormControl({ value: false, disabled: !this.getVDetector(detect.family, detect.name)['active'] })
        },
          { validators: allFalse }))
      }
    }
  }

  getFormFam(family: string) {
    return this.formDetectorActive.get(family) as UntypedFormGroup
  }

  getFormFamDetect(fam: string, name: string) {
    let famG = this.getFormFam(fam)
    return famG.get(name) as UntypedFormGroup
  }

  getOptions(family: string, detect: string) {
    let formFam = this.formDetectorActive.get(family.toLowerCase()) as UntypedFormGroup
    let formDetect = formFam.get(detect.toLowerCase()) as UntypedFormGroup
    return formDetect.get("typeactiveinapp") as UntypedFormGroup
  }

  getVDetector(family: string, detector: string) {
    return this.formDetectorActive.value[family.toLowerCase()][detector.toLowerCase()]
  }

  setStatut(value: string, family: string, detector: string) {
    this.getFormFam(family).get(detector)?.patchValue({ status: value.toUpperCase() })
  }

  toogle(event: MatSlideToggleChange, family: string, detector: string) {
    this.getFormFam(family.toLowerCase()).get(detector.toLowerCase())?.patchValue({ active: event.checked })
    if (event.checked) {
      this.setStatut('warning', family.toLowerCase(), detector.toLowerCase())
      this.formDetectorActive.patchValue({ [family.toLowerCase()]: { [detector.toLowerCase()]: { typeactiveinapp: { in_demand: true, periodic: true } } } })
      this.getOptions(family, detector).get('in_demand')?.enable()
      this.getOptions(family, detector).get('periodic')?.enable()
    }
    if (!event.checked) {
      this.setStatut('', family.toLowerCase(), detector.toLowerCase())
      this.formDetectorActive.patchValue({ [family.toLowerCase()]: { [detector.toLowerCase()]: { typeactiveinapp: { in_demand: false, periodic: false } } } })
      this.getOptions(family, detector).get('in_demand')?.disable()
      this.getOptions(family, detector).get('periodic')?.disable()
    }
  }

  haveChange(family: string) {
    let hc = false
    let formFamily = this.formDetectorActive.value[family.toLowerCase()]
    let detectFamily = Backend.POLICIES.getDetectorsByFamily(this.policy, family)
    if (detectFamily && formFamily) {
      for (let detector of detectFamily) {
        let detec = detector.name.toLowerCase()
        let dactif = this.policy?.activatedDetectors?.find(elem => {
          if (elem.policyDetectorId) {
            return elem.policyDetectorId.detector.name == detec && elem.policyDetectorId.detector.id == detector.id
          } else { return false }
        })
        if (dactif) {
          if (!formFamily[detec]['active'] || dactif.status != formFamily[detec]['status'] || !this.matchLaunch(dactif, formFamily[detec]['typeactiveinapp'])) {
            hc = true
          }
        } else if (formFamily[detec]['active']) {
          hc = true
        }
      }
    }
    return hc
  }

  checkForm(family: string) {
    let correct = true
    let formFamily = this.formDetectorActive.value[family.toLowerCase()]
    let detectFamily = Backend.POLICIES.getDetectorsByFamily(this.policy, family)
    if (detectFamily && formFamily) {
      for (let detector of detectFamily) {
        let detec = detector.name.toLowerCase()
        if (formFamily[detec]['active'] && this.getOptions(family.toLowerCase(), detec).invalid) {
          correct = false
        }
      }
    }
    return correct
  }


  matchLaunch(activatedDetectors: ActivatedDetector, formtypelaunch: any) {
    if (formtypelaunch) {
      if (activatedDetectors.launchOnDemand === formtypelaunch['in_demand'] && activatedDetectors.launchOnPeriodic === formtypelaunch['periodic']) {
        return true
      } else { return false }
    }
    else {
      return false
    }
  }

  resetFamily(family: string) {
    let keys = Object.keys(this.getFormFam(family.toLowerCase()).controls)
    for (let k of keys) {
      this.getFormFam(family.toLowerCase()).removeControl(k)
    }
    let detecFam = Backend.POLICIES.getDetectorsByFamily(this.policy, family)
    if (detecFam) {
      detecFam.forEach(d => this.initFormForDetect(d))
    }
  }

  allFormMatch() {
    let bool = false
    if (this.policy) {
      for (let fam of Backend.POLICIES.getAllFamilyofDetectors(this.policy)) {
        if (this.haveChange(fam) && this.checkForm(fam)) {
          bool = true
        }
      }
      if (this.getFormControl('name')) {
        if (this.getFormControl('name').value !== this.policy.name && !this.getFormControl('name').errors) {
          bool = true
        }
      }
    }
    return bool
  }

  saveChange() {
    if (this.policy) {
      this.policy.activatedDetectors = Backend.POLICIES.formatActiveDetectorsToPost(this.collectNewActivatedDetectors());
      this.policy.name = this.formDetectorActive.value['name'];
    }

    const keyAdd = 'security-policies-toast-add';
    const keyEdit = 'security-policies-toast-edit-change';
    const keyPolicy = 'security-policies-toast-policy';

    const actionKey = this.create ? keyAdd : keyEdit;

    forkJoin({
      policyLabel: this.translationService.get(keyPolicy),
      action: this.translationService.get(actionKey)
    }).subscribe(({ policyLabel, action }) => {
      const toast = this.policy ? `${policyLabel}${this.policy.name}${action}` : undefined;

      if (toast && this.policy) {
        this.editP.emit({ policy: this.policy, toast: toast, nameClient: this.nameClient });
        this.create = false;
      }
    });
  }

  private collectNewActivatedDetectors(): ActivatedDetector[] {
    let newActivatedDetectors: ActivatedDetector[] = [];
    if (!this.policy) return newActivatedDetectors;

    for (let fam of Backend.POLICIES.getAllFamilyofDetectors(this.policy)) {
      const detecFam = Backend.POLICIES.getDetectorsByFamily(this.policy, fam);
      if (detecFam) {
        detecFam.forEach(detect => {
          const vDetector = this.getVDetector(fam, detect.name);
          if (vDetector["active"]) {
            let newAD: ActivatedDetector = {
              launchOnDemand: vDetector['typeactiveinapp']['in_demand'],
              launchOnPeriodic: vDetector['typeactiveinapp']['periodic'],
              status: vDetector['status'],
              policyDetectorId: { detector: detect }
            };
            newActivatedDetectors.push(newAD);
          }
        });
      }
    }
    return newActivatedDetectors;
  }


  getControl(name: string, formG: UntypedFormGroup) {
    return formG.get(name) as UntypedFormControl
  }

  private findActivatedDetector(detector: Detectors): ActivatedDetector | undefined {
    return this.policy?.activatedDetectors?.find(elem =>
      elem.policyDetectorId &&
      elem.policyDetectorId.detector.name === detector.name &&
      elem.policyDetectorId.detector.id === detector.id
    );
  }

  statutactive(detector: Detectors): string {
    return this.findActivatedDetector(detector) ? '' : 'inactive';
  }

  formatStatus(detector: Detectors): string {
    const dactif = this.findActivatedDetector(detector);
    const st = dactif?.status?.toLowerCase();
    return this.safeFormat(() => Backend.POLICIES.formatStatut(st));
  }

  fStatusString(status: string): string {
    return this.safeFormat(() => Backend.POLICIES.formatStatut(status));
  }

  formatPId(detector: Detectors): string {
    const dactif = this.findActivatedDetector(detector);
    const lstatus: string[] = [];
    if (dactif) {
      if (dactif.launchOnDemand) lstatus.push('on demand');
      if (dactif.launchOnPeriodic) lstatus.push('periodic');
    }
    return this.safeFormat(() => Backend.POLICIES.formatPId(lstatus));
  }

  /** Utilitaire pour garantir un retour string, même si la méthode Backend retourne autre chose */
  private safeFormat(fn: () => any): string {
    const result = fn();
    return typeof result === 'string' ? result : '';
  }

  public getFatalLength(family: string): number {
    return Backend.POLICIES.getFatalLength(this.policy?.activatedDetectors, family);
  }

  public getTotalLength(family: string): number {
    return Backend.POLICIES.getTotalLength(this.policy?.bwVersion?.listDetectors, family);
  }

  public async getPolicy(): Promise<void> {
    if (this.policy?.id) {
      this.policy = await Backend.POLICIES.getPolicyById(this.policy.id);
    }
  }

  public sendAction(action: string): void {
    if (this.policy) {
      this.sendClose('Cross click');
      this.action.emit(action);
    }
  }
}
